import { AxiosError, AxiosResponse } from "axios";
import * as React from "react";
import {
  Button,
  Col,
  Collapse,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import "./subCategory.scss";
import { ReactComponent as BackGray } from "../../../images/backGray.svg";
import "./styles.css";

import { toast } from "react-toastify";
import {
  HistoryInfo,
  OptionsPayload,
  Question,
  SubCategoryQuestionsForCompliance,
  saveQuestionReview,
} from "../../../models/ComplianeQuestionarie";
import Service from "../../../services";
import { BankUserContext } from "../../../bankUserContext";
import { ParseJson, catchError } from "../../../utils/Utils";
import FinSpinner from "../../../commonfields/FinSpinner";
import { CompilanceQuestionnaireComponent } from "dynamic-questionarie";
import { CategoryDetails, postQuestionData } from "../../../models/ClientPortalCategoriesDetails/CategoriesDetails";
import { WithRouterProps, withRouter } from "../../shared/WithRouter";
import OwnershipQuestionnaireComponent from "../ClientportalDashboardComponents/ReadonlyOwneshipQuestionnaireForm/OwnershipQuestionnaire";
import { Nav, Tab } from "react-bootstrap";
import moment from "moment";
import history from "../../../images/history.svg";
import comment from "../../../images/comment.svg";
import backGray from "../../../images/backGray.svg";
import ReactFileViewer from "../../../commonfields/ReactFileViewer";
import { RoutesEnum } from "../../../utils/RoutesUtil";
import MessageCenterModal from "../../MessageCenter/QuestionarieMC/MessageCenterModal";
import { MessageThread, MessageThreadImpl } from "../../../models/QuestionarieMCModal";
import { LeadDetailsModel } from "../../../models/Lead/LeadDetails";
import MessageChatWindowFC from "../../MessageCenter/QuestionarieMC/MessageChatWindowFC";

export interface StateProps {
  data: any;
  refreshData: boolean;
  parentCategoryName: string;
  spinner: boolean;
  questions: Question[];
  count: number;
  disableNewTaskButton: boolean;
  status: any;
  questionHistory: Array<HistoryInfo>;
  historyModal: boolean;
  guidanceModel: boolean;
  guidance: any;
  guidanceToggle: number;
  fileHandleModal: boolean;
  file: any;
  messageModal: boolean;
  selectedMessageThread: any;
  clientUserId: string;
  selectedQuestion: null | Question;
  refreshCounter: number;
  clientDetails: LeadDetailsModel | undefined;
}

class QuestionnaireReview extends React.Component<
  WithRouterProps<unknown>,
  StateProps
> {
  static contextType = BankUserContext;
  context: React.ContextType<typeof BankUserContext> | undefined;
  constructor(props: any) {
    super(props);
    this.state = {
      data: undefined,
      refreshData: false,
      parentCategoryName: "",
      spinner: false,
      questions: [],
      count: 0,
      disableNewTaskButton: false,
      status: "",
      questionHistory: [],
      historyModal: false,
      guidanceModel: false,
      guidance: [],
      guidanceToggle: 0,
      fileHandleModal: false,
      file: null,
      messageModal: false,
      selectedMessageThread: new MessageThreadImpl(),
      clientUserId: "0",
      selectedQuestion: null,
      refreshCounter: 0,
      clientDetails: undefined
    };
  }
  service = new Service();
  // static contextType = BankUserContext;

  categoryId = this.props.params.categoryId;
  subcategoryId = this.props.params.subCategoryId;
  clientProductId = this.props.params.clientProductId;
  componentDidMount() {
    this.getquestions();
    this.getDetails();
  }

  addNewQuestions = () => {
    const count = this.state.count;
    // const questionSequenceIds=this.state.questions.map((m:Question)=>{ return m.questionSequence})
    const questionSequence = 0;
    const questionDummy: Question = {
      answers: [],
      questionId: count,
      questionTypeId: 5,
      questionType: "FileUpload",
      helpText: "",
      questionText: "",
      questionSequence: questionSequence,
      shortCode: "Default",
      questionGroupId: null,
      questionGroupName: "",
      displayHorizontal: true,
      clientQuestionId: count,
      questionMappingId: count,
      layoutType: null,
      reviewClientQuestionId: null,
      reviewAccepted: false,
      reviewFlagged: false,
      reviewNotes: null,
      complianceGroupId: count,
      complianceGroupName: "",
      layoutOffset: null,
      layoutPreset: null,
      layoutCoulmns: null,
      isRequired: null,
      serialNumber: count,
      isRepetitive: false,
      questionGroupHideHeading: false,
      questionGroupHeadingSize: 14,
      questionGroupHeaderTemplate: "",
      dependentQuestionGroupHideHeading: false,
      dependentQuestionGroupHeadingSize: 14,
      complianceGroupHideHeading: false,
      complianceGroupHeadingSize: 14,
      flaggedReason: "",
      options: [],
      dependent: false,
      denpendentQuestionGroupId: null,
      denpendentQuestionGroupName: null,
      isCustomQuestion: true,
      complianceCategoryStatus: true,
      clientCustomQuestion: false,
      naCustomDelete: false,
      createdDate: new Date(),
      banking: false,
    };

    this.setState((prevState) => ({
      questions: [...prevState.questions, questionDummy],
      disableNewTaskButton: true,
    }));
  };

  historyModalViewHandler = () => {
    this.setState({ historyModal: !this.state.historyModal });
  };

  guidanceModelHandler = () => {
    this.setState({ guidanceModel: !this.state.guidanceModel });
  };

  addCustomQuestion = (body: any) => {
    const data = {
      clientProductId: this.props?.params.clientProductId,

      subcategoryId: this.props?.params.subCategoryId,

      questionText: body.FileUploadText,

      helpText: body.FileUploadText,

      questionTypeId: "2",
    };
    this.service
      .addClientCustomQuestion(data)
      .then(() => {
        this.setState({ refreshData: false });
        this.getquestions();
        this.setState({ disableNewTaskButton: false });
      })
      .catch((error: any) => {
        catchError(error, true);
      });
  };

  removeQuestion = (question: Question) => {
    this.service
      .removeClientCustomQuestion(question.clientQuestionId, true)
      .then(() => {
        this.getquestions();
        this.setState({ disableNewTaskButton: false });
      });
  };

  removeCustomQuestion = () => {
    this.getquestions();
    this.setState({ disableNewTaskButton: false });
  };
  postSavequestionReview = (body: saveQuestionReview) => {
    this.setState({ refreshData: false, spinner: true });
    this.service
      .postsaveQuestionReview(body)
      .then(() => {
        setTimeout(() => {
          this.getquestions();
        }, 300);
      })
      .catch((error: AxiosError) => {
        this.setState({ spinner: false });
        catchError(error, true);
      });
  };

  getquestions = () => {
    this.setState({ spinner: true });

    if (this.categoryId) {
      this.subcategoryId &&
        this.service
          .getComplinaceQuestionsBySubCategoryId(
            this.props?.params.clientProductId,
            this.props?.params.subCategoryId
          )
          .then(
            (response: AxiosResponse<SubCategoryQuestionsForCompliance>) => {
              this.setState({
                data: response.data,
                refreshData: true,
                spinner: false,
                questions: response.data.questions,
              });
            }
          )
          .catch((error: AxiosError) => {
            this.setState({ spinner: false });
            catchError(error, true);
          });
      this.service
        .getcategoryDetails(
          this.props?.params.categoryId,
          this.props.params.clientProductId
        )
        .then((response: AxiosResponse<CategoryDetails>) => {
          this.setState({
            parentCategoryName: response?.data?.name,
            spinner: false,
          });
        })
        .catch((error: AxiosError) => {
          catchError(error, true);
          this.setState({ spinner: false });
        });
    }
  };

  back = () => {
    this.props.navigate(
      `/${RoutesEnum.CLIENT_QUESTIONARIE}/subCategories/${this.props?.params.screenType}/${this.props?.params.categoryId}/${this.props?.params.clientProductId}`,
      { state: this.props.location.state }
    );
  };

  getDetails = () => {
    this.service.getUserIdByClientId(this.props.params.clientProductId).then(resp => {
      this.setState({ clientUserId: resp?.data?.userId });
    }).catch((error: AxiosError) => {
      catchError(error, true);
    })
    this.service.getLeadInfoDetails(this.props.params.clientProductId).then((response: AxiosResponse<LeadDetailsModel>) => { this.setState({ clientDetails: response.data }) }).catch((error: any) => {

      toast.error("Something went Wrong")
    })
  }

  setIsOpen = (index: number) => {
    if (index === this.state.guidanceToggle) {
      this.setState({ guidanceToggle: -1 });
    } else {
      this.setState({ guidanceToggle: index });
    }
  };

  getQuestionThread = (clientQuestionId: any, cf?: string) => {
    const mt = new MessageThreadImpl();
    cf && this.setState({ selectedMessageThread: mt })
    this.service.getMessageThreadsByQuestionId(this.state.clientUserId, clientQuestionId).then(resp => {
      /**
       * Checking whether question is having message thread or not
       */
      if (resp && resp.data) {
        this.setState({ selectedMessageThread: resp.data })

      }
    }).catch((err: any) => {
      cf && this.setState({ selectedMessageThread: mt })
    })
  };

  messageCenter = (question: Question) => {
    const { clientDetails, clientUserId } = this.state;
    if (this.props.location.state?.editable) {
      const data = {
        messages: '',
        contextPurpose: '',
        subject: (question?.complianceGroupName ? (question?.complianceGroupName) : (question?.questionText)),
        clientName: clientDetails?.firstName ? (clientDetails?.firstName + ' ' + clientDetails?.lastName) : "",
        clientCompany: clientDetails?.company || "",
        createdBy: this.context?.bankuserDetails?.userId?.toString(),
        sentTo: clientUserId,//clientDetails?.clientId || 0,
        message: '',
        id: '',
        createdAt: '',
        readFlag: false,
        archiveFlag: false,
        pinnedFlag: false,
        clientId: clientDetails?.clientId
      }
      this.getQuestionThread(question?.clientQuestionId);
      this.setState({ selectedMessageThread: data, selectedQuestion: question, messageModal: true })
    }
  };

  history = (reviewClientQuestionId: any, clientQuestionId: any) => {
    clientQuestionId && this.getQuestionThread(clientQuestionId, 'history');
    if (reviewClientQuestionId !== null) {
      this.service
        .getIteamHistory(reviewClientQuestionId)
        .then((response: AxiosResponse<Array<HistoryInfo>>) => {      
          this.setState({ questionHistory: response.data });
          // setQuestionHistory(response.data);

        });
    }
    else {
      this.setState({ questionHistory: [] });
    }
    this.historyModalViewHandler();
  };

  guidance = (list: any) => {
    this.service
      .getQuestionGuidance({ questionId: list })
      .then((response: any) => {
        this.setState({ guidance: response.data });
        this.guidanceModelHandler();
      })
      .catch((error: AxiosError) => {
        catchError(error, false);
      });
  };

  fileClick = (file: any) => {
    this.setState({ spinner: true });
    this.service
      .getFile(file?.filePath)
      .then((response: any) => {
        if (response.data) {
          const data = { ...response.data, uri: response.data.fileContent };
          this.setState({ file: data });
        }
        this.openFileViewHandler();
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      })
      .finally(() => {
        this.setState({ spinner: false });
      });
  };

  savequestion = (question: Question, oldAnswer: any) => {
    this.setState({ spinner: true });

    if (
      question.answers &&
      question.answers?.length > 0 &&
      question.answers[0].answer !== ""
    ) {
      if (question.questionType == "FileUpload" && question.answers) {
        const fileObj = question?.answers[0].answer;
        this.setState({ refreshData: false });
        this.service
          .postFile(fileObj, question.clientQuestionId)
          .then((res: any) => {
            const allQuestions = Object.assign([], this.state.data);
            const currentQuestion = allQuestions.questions.find(
              (m: any) => m.clientQuestionId == question.clientQuestionId
            );
            if (currentQuestion) {
              currentQuestion.answers = [{ answer: res.data, optionId: null }];
              this.setState({
                questions: allQuestions.questions,
                refreshData: true,
              });
            }
          })
          .catch((error: any) => {
            toast.error("something went wrong");
            this.getquestions();
          })
          .finally(() => {
            this.setState({ spinner: false });
          });
      }
      else {
        //save the response
        const postQuestionData1: postQuestionData = {
          answer: "",
          clientQuestionId: question.clientQuestionId,
          clientProductId: this.clientProductId,
          options: [],
          requireCopy: false,
        };
        // text, date, text area, signle selection
        postQuestionData1.answer = question.answers[0].answer;
        if (question.options.length > 0) {
          postQuestionData1.options = question.answers.map((item) => {
            const data1: OptionsPayload = {
              questionOptionId: item.optionId,
              answer: item.answer,
            };
            return data1;
          });
        }
        
        this.service.postSaveClientResponse(postQuestionData1).then((response:any)=>{
          this.setState({spinner:false})
        })
          .catch((err: AxiosError) => {
            catchError(err, true);
            this.setState({spinner:false});
          });
      }
    } else {
      if (
        oldAnswer[question.clientQuestionId] &&
        oldAnswer[question.clientQuestionId].length > 0
      ) {
        let filePath = null;
        if (
          oldAnswer[question.clientQuestionId][0].answer &&
          typeof oldAnswer[question.clientQuestionId][0].answer === "string"
        ) {
          const fileObj = ParseJson(
            oldAnswer[question.clientQuestionId][0].answer
          );
          if (fileObj && fileObj.filePath) {
            filePath = fileObj.filePath;
          }
        } else if (
          oldAnswer[question.clientQuestionId][0].answer &&
          typeof oldAnswer[question.clientQuestionId][0].answer === "object"
        ) {
          const fileObj = oldAnswer[question.clientQuestionId][0].answer;
          if (fileObj && fileObj.filePath) {
            filePath = fileObj.filePath;
          }
        } else if (
          typeof oldAnswer[question.clientQuestionId][0] === "object"
        ) {
          filePath = oldAnswer[question.clientQuestionId][0].filePath;
        }
        this.service
          .deleteComplianceFile(question.clientQuestionId, filePath)
          .catch((error: any) => {
            catchError(error, true);
          })
          .finally(() => {
            this.setState({ spinner: false });
          });
      }
    }
  };

  sendMsg = async (question: any) => {

  };

  messageSend = () => {
    const _refreshCounter = this.state.refreshCounter + 1;
    if (!this.state.selectedMessageThread.id) {
      this.getQuestionThread(this.state.selectedQuestion?.clientQuestionId);
    } else {
      // setRefreshCounter(_refreshCounter);
      this.setState({ refreshCounter: _refreshCounter });
    }
  };

  toggle = () => {
    if (this.state.messageModal) {
      // readNotification();
    }
    this.setState({ messageModal: !this.state.messageModal });
  };

  setLoader = (value: boolean) => this.setState({ spinner: value });

  openFileViewHandler = () =>
    this.setState({ fileHandleModal: !this.state.fileHandleModal });

  fieldsDisable = (complainceCatgeoryFlag: boolean) => {
    if (this.props.location.state?.editable) {
      return !complainceCatgeoryFlag
    } else {
      return true
    }
  }

  render() {
    const {
      questionHistory,
      historyModal,
      guidanceModel,
      guidanceToggle,
      guidance,
    } = this.state;
    return (
      <>
        {this.state.spinner && <FinSpinner />}
        <div className="subCategoryContainer">
          <span onClick={this.back} className="categoryHeader">
            <Button onClick={this.back} className="backBtn">
              <BackGray />
            </Button>
            {this.state.parentCategoryName}
          </span>
          <div className="containerHeading">
            <div className="subCategoryHeader">{this.state?.data?.name}</div>
            {this.props.location.state.editable && this.state.data?.complianceCategoryFlag && (
              <div
                className={`${this.state.disableNewTaskButton
                  ? "addButtonContainerdisable"
                  : "addButtonContainer"
                  }`}
              >
                <button
                  onClick={() => this.addNewQuestions()}
                  disabled={this.state.disableNewTaskButton}
                >
                  Add new task
                </button>
              </div>
            )}
          </div>
          <div>
            {this.state.data?.name === "Ownership Information" ? (
              <OwnershipQuestionnaireComponent
                clientId={this.state.clientDetails?.clientId}
                clientProductId={this.props.params.clientProductId}
                complianceMode={true}
                status={this.state.status}
                questionsData={
                  this.state.data !== undefined ? this.state.questions : []
                }
                postsavequestion={this.postSavequestionReview}
                refreshQuestionsData={this.state.refreshData}
                loader={this.state.spinner}
                setLoader={this.setLoader}
                match={undefined}
                onClickMessageCenter={this.messageCenter}
                onClickHistory={this.history}
                onClickGuidance={this.guidance}
                disableActions={!this.props.location.state?.editable}
              />
            ) : (
              <CompilanceQuestionnaireComponent
                questionsData={
                  this.state.data !== undefined ? this.state.questions : []
                }
                refreshQuestionsData={this.state.refreshData}
                disableFields={this.fieldsDisable(this.state.data?.complianceCategoryFlag)}
                postsavequestion={this.postSavequestionReview}
                addCustomQuestion={this.addCustomQuestion}
                removeCustomQuestion={this.removeCustomQuestion}
                removeQuestion={this.removeQuestion}
                onSavequestion={this.savequestion}
                status={this.state.status}
                onClickMessageCenter={this.messageCenter}
                onClickHistory={this.history}
                onClickGuidance={this.guidance}
                onClickFile={this.fileClick}
                disableActions={!this.props.location.state?.editable}

              />
            )}

            <div className="btnWrapper">
              <Button className="bottomButton" onClick={this.back}>
                Back to {this.state.parentCategoryName}
              </Button>
            </div>
          </div>
        </div>
        <div className="fileViewerModalContainer">
          <Modal
            className=" mw-100 w-50 fileViewerModalWrapper"
            isOpen={this.state.fileHandleModal}
            fade={false}
            toggle={this.openFileViewHandler}
          >
            <ModalHeader
              toggle={this.openFileViewHandler}
              className="tc_heading"
            >
              <span>{this.state.file?.fileName} </span>
            </ModalHeader>
            <ModalBody>
              <div className="TC_fileView">
                {this.state.spinner ? (
                  <FinSpinner />
                ) : this.state.file ? (
                  <ReactFileViewer fileDocument={this.state.file} />
                ) : (
                  ""
                )}
              </div>
            </ModalBody>
          </Modal>
        </div>
        <Modal
          className="popup-modal modelWrap historyModal"
          size="md"
          isOpen={historyModal}
          fade={false}
          toggle={this.historyModalViewHandler}
        >
          <ModalBody>
            <button
              type="button"
              className="close"
              aria-label="Close"
              onClick={this.historyModalViewHandler}
            >
              <span aria-hidden="true">×</span>
            </button>
            <Tab.Container id="historyTabs" defaultActiveKey="itemHistory">
              <Row>
                <Col sm={12}>
                  <Nav variant="pills" id="historyNav" className="mb-3">
                    <Nav.Item>
                      <Nav.Link eventKey="itemHistory">
                        <img src={history} alt="" />
                        <span>Item History</span>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="messageHistory">
                        <img src={comment} alt="" />
                        Message History
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Col>
              </Row>
              <Row>
                <Col sm={12}>
                  <Tab.Content>
                    <Tab.Pane
                      className="tabElement historyModalTab"
                      eventKey="itemHistory"
                    >
                      <div>
                        <div className="historyModel">
                          {questionHistory[0]?.historyDTO&& questionHistory[0]?.historyDTO?.length > 0 ? (
                            questionHistory !== undefined &&
                            questionHistory[0]?.historyDTO?.map(
                              (element: any) => (
                                <Row className="infoPack">
                                  <Col md="2">{element.firstName}</Col>
                                  <Col md="1" className="">
                                    {moment(
                                      moment.utc(element.createdDate).toDate()
                                    ).format("M/DD/YY")}
                                  </Col>
                                  <Col md="2" className="timeDate">
                                    {moment(
                                      moment.utc(element.createdDate).toDate()
                                    ).format("hh:mm A")}
                                  </Col>
                                  <Col>{element.info}</Col>
                                </Row>
                              )
                            )
                          ) : (
                            <Row className="infoPack">
                              <Col>No records found</Col>
                            </Row>
                          )}
                        </div>
                      </div>
                    </Tab.Pane>
                    <Tab.Pane
                      className="tabElement historyModalTab"
                      eventKey="messageHistory"
                    >
                      <div className="message-modal">
                        {this.state.selectedMessageThread.messages && this.state.selectedMessageThread.messages.length > 0 ?
                          <MessageChatWindowFC messageThread={this.state.selectedMessageThread}
                            refreshCounter={this.state.refreshCounter}></MessageChatWindowFC> :
                          <Row className="infoPack">
                            <Col>No records found</Col>
                          </Row>}
                      </div>
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </ModalBody>
        </Modal>

        <MessageCenterModal
          messageModal={this.state.messageModal}
          toggleMessageModal={this.toggle}
          refreshCounter={this.state.refreshCounter}
          messageThread={this.state.selectedMessageThread}
          messageSend={this.messageSend}
          clientDetails={this.state.clientDetails}
          clientUserId={this.state.clientUserId}
          question={this.state.selectedQuestion}
        // disableforsuperuser={}
        />

        <Modal
          className="popup-modal guidanceWrapper"
          size="md"
          isOpen={guidanceModel}
          fade={false}
          toggle={this.guidanceModelHandler}
        >
          <ModalHeader className="guidance" toggle={this.guidanceModelHandler}>
            Guidance
          </ModalHeader>
          <div>
            <div className="guidanceBody">
              {guidance &&
                guidance?.map((element: any, index: number) => (
                  <>
                    <Row>
                      <Col md="12">
                        <div
                          onClick={() => this.setIsOpen(index)}
                          className="question"
                        >
                          {index == guidanceToggle ? (
                            <img
                              src={backGray}
                              alt=""
                              className="downArrow arrow"
                            />
                          ) : (
                            <img src={backGray} className="arrow" alt="" />
                          )}
                          {
                            this.state.questions?.find(
                              (ele: Question) =>
                                ele.questionId === element.questionId
                            )?.questionText
                          }
                        </div>
                      </Col>
                      <Col md="12">
                        <Collapse isOpen={index == guidanceToggle}>
                          <p className="guidanceContent">{element?.guidance}</p>
                        </Collapse>
                      </Col>
                    </Row>
                  </>
                ))}
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

export default withRouter<WithRouterProps<unknown>>(QuestionnaireReview);
